module.exports = __webpack_public_path__ + "img/logo-white.6e55769f.png";